export default "__VITE_ASSET__692a3fc4__"